import React, { useEffect, useState } from "react";
import ContentBox from "./ContentBox";
import { ClientSelectSuministroElectrico } from "./ClientSelectSuministroElectrico";
import { suministroElectricoDetalleDeuda } from "../api";
import {urls} from '../config.js';
import TagManager from 'react-gtm-module';

export function ServiciosSuministroElectricoDetalleDeuda({
  loading,
  services,
  selectedSuministroElectrico,
  setSelectedSuministroElectrico,
  user,
}) {
  const [deuda, setDeuda] = useState(null);
  const [loadingDeuda, setLoadingDeuda] = useState(false);

  useEffect(() => {
    if (selectedSuministroElectrico) {
      setLoadingDeuda(true);
      setDeuda(null);
      suministroElectricoDetalleDeuda(selectedSuministroElectrico.abastible_contract_id, (error, result) => {
        if (error) return;
        setDeuda(result.data);
        setLoadingDeuda(false);
      })
    }
  }, [selectedSuministroElectrico])

  const paymentPortal = () =>{
    let url = '';
    url = urls.portal_pago + 'ssee?codCliente=' + Number(selectedSuministroElectrico.abastible_contract_id).toString() + '&email=' + user.email + '&movil=' + user.phone;
    TagManager.dataLayer({
      dataLayer:{
        event:'pagar_cuenta_medidor',
        codCliente:  Number(selectedSuministroElectrico.abastible_contract_id).toString(),
        email: user.email,
        movil: user.phone,
      }
    })
    window.open(url, '_blank');
      window.focus();
  }

  return (
    <ContentBox loading={loading || !services}>
      <div className="flex flex-col gap-12 w-full max-w-4xl mx-auto">
        <div>
          <h1 >Detalle de Deuda</h1>
          <div className="client-number">
            <ClientSelectSuministroElectrico
              selected={selectedSuministroElectrico}
              services={services}
              number_field={"client_cod"}
              setSelected={setSelectedSuministroElectrico}
            />
          </div>
        </div>
        {!selectedSuministroElectrico ?
          <div className="flex justify-center items-center h-full">
            <p className="text-center">Selecciona un cliente para ver el detalle de la deuda</p>
          </div>
          : (
            <div className="flex justify-center gap-12 w-full flex-col md:flex-row">
              {false?
              <div className="flex flex-col gap-12 w-full">
                <div className="flex flex-col gap-4">
                  <p className="font-bold">Detalle de la deuda</p>
                  <div>
                    <p className="uppercase text-sm opacity-70">Saldo anterior</p>
                    <p className="font-bold text-lg">{Number(deuda?.previous_debt||0)?.toLocaleString("es-CL", {
                      style: "currency",
                      currency: "CLP"
                    })} </p>
                  </div>
                  <div>
                    <p className="uppercase text-sm opacity-70">Deuda vigente</p>
                    <p className="font-bold text-lg">{Number(deuda?.current_debt||0)?.toLocaleString("es-CL", {
                      style: "currency",
                      currency: "CLP"
                    })} </p>
                  </div>
                </div>
              </div>
              :null}
              <div className="rounded-sm bg-muted px-4 py-6 flex gap-12 pr-16 flex-wrap">
                <div className="flex flex-col gap-4 w-fit">
                  <div>
                    <h3 className="text-sm opacity-70 uppercase">Última boleta vence</h3>
                    <p className="font-bold text-lg">{deuda?.document_due_date ?? 'No hay boleta'}</p>
                  </div>
                  <div>
                    <h3 className="text-sm opacity-70 uppercase">Último pago</h3>
                    <p className="font-bold text-lg">{deuda?.last_payment_date ?? 'No hay pago'}</p>
                  </div>
                </div>
                <div className="flex flex-col gap-4 w-fit">
                  <div>
                    <h3 className="text-sm opacity-70 uppercase">Tu deuda vigente es</h3>
                    <p className="font-bold text-6xl" style={{fontSize:'2.25rem'}}>{Number(deuda?.amount||0)?.toLocaleString("es-CL", {
                      style: "currency",
                      currency: "CLP"
                    })} </p>
                    {deuda?.document_number ? (
                      <p className="flex gap-2 items-center whitespace-nowrap">N° de boleta <span className="font-bold">{deuda?.document_number}</span></p>
                    ) : null}
                  </div>
                  <button type="button" className="button green col-inherit" onClick={paymentPortal} >Pagar Cuenta</button>

                </div>
              </div>
            </div>
          )}
      </div>
    </ContentBox>
  );
}
